import { gql } from '@apollo/client';

export const COLLECTION_FRAGMENT = gql`
  fragment CollectionFragment on Collection {
    id
    name
    type
    categoryId
    asset
    levels {
      rewards {
        type
        amount
        itemId
      }
      items {
        itemLevel
        type
        itemId
      }
    }
    isDraft
  }
`;

export const GET_COLLECTIONS = gql`
  query collections($limit: Int, $offset: Int) {
    liveOps {
      collections(limit: $limit, offset: $offset) {
        list {
          ...CollectionFragment
        }
        totalCount
      }
    }
  }
  ${COLLECTION_FRAGMENT}
`;

export const UPDATE_COLLECTION = gql`
  mutation updateCollection($input: UpdateCollectionInput!) {
    updateCollection(input: $input) {
      ...CollectionFragment
    }
  }
  ${COLLECTION_FRAGMENT}
`;

export const CREATE_COLLECTION = gql`
  mutation createCollection($input: CreateCollectionInput!) {
    createCollection(input: $input) {
      ...CollectionFragment
    }
  }
  ${COLLECTION_FRAGMENT}
`;

export const REMOVE_COLLECTION = gql`
  mutation removeCollection($collectionId: ID!) {
    removeCollection(collectionId: $collectionId) {
      id
    }
  }
`;

export const UPLOAD_COLLECTION_ASSET = gql`
  mutation uploadCollectionAssets($input: UploadCollectionAssetInput!) {
    uploadCollectionAssets(input: $input) {
      ...CollectionFragment
    }
  }
  ${COLLECTION_FRAGMENT}
`;
